<template>
    <projeto-resultados 
        :projeto-id="projetoIdBase" 
        :titulo="titulo" 
        :colunas="colunas" 
        :rubrica="rubrica" 
        :componente="componente" 
        :endpoint="endpoint" 
        @update="update"

        :chave-permissao="chavePermissao"
        :projeto-editavel="projetoEditavel"
    />
</template>
<script>
import helpers from "@/common/utils/helpers";
import ProjetoResultados from "../componentes/Resultados"
export default {
    components : {
        ProjetoResultados
    },
    props : ['projetoId', 'projetoIdBase', 'endpoint', 'chavePermissao', 'projetoEditavel'],
    data : () => ({
        colunas : [
            { key: 'tipo', label: "Indicador",
                formatter: (value) => {
                    if (value) return  helpers.getEnum(value).text;
                },
            },
            { key: "descricao", label: "Descrição do benefício", },
            { key: "unidade", label:"Unidade base"},
            { key: "base", label:"Valor do indicador"},
            { key: "percentual", label:"% de impacto"},
            { key: "valor", label:"Valor do benefício", 
                formatter: (value) => {
                    if (value) return helpers.formatarValor(value);
                },
            },
        ],
        componente : 'impacto-economico',
        rubrica : 'impacto-economico',
        titulo : 'Impactos Econômicos'
    }),
    methods : {
        update : function(){
            this.$emit('update');
        }
    }
}
</script>
<style>
    
</style>